import styled, { css } from 'styled-components'

import { colors } from 'app/theme/colors'

const breakpoint = '1024px'

export const Body = styled.div`
  height: 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
`

export const Content = styled.div`
  font-size: 20px;
  font-family: AvenirDemi;
  text-overflow: ellipsis;
  overflow: hidden;
  // text-transform: lowercase;
  color: ${colors.textPrimary};
  ${(props) =>
    props.plan &&
    css`
      font-family: AvenirDemi;
      font-size: 40px;
    `}

  ${(props) =>
    props.subheading &&
    css`
      font-family: AvenirMedium;
      font-size: 12px;
      text-transform: uppercase;
    `}
  
      ${(props) =>
    props.heading &&
    css`
      font-family: AvenirMedium;
      font-size: 14px;
    `}

    ${(props) =>
    props.type &&
    css`
      color: ${props.type === 'light'
        ? colors.textTertiary
        : props.type === 'medium'
          ? colors.textSecondary
          : colors.textPrimary};
    `}

    ${(props) =>
    props.color &&
    css`
      color: ${props.color};
    `}
`

export const ColumnFlexStart = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: column;
  gap: 10px;
`

export const ColumnFlexEnd = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
  flex-direction: column;
`

export const ColumnFlexGap = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  gap: 16px;
`

export const ColumnFlexCenter = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 8px;
`

export const RowFlexStart = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: flex-start;
  flex-direction: row;
  gap: 4px;
`

export const RowFlexGap = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 20px;
`

export const Heading = styled.div`
  font-family: AvenirMedium;
  font-size: 14px;
  line-height: 24px;
`

export const Image = styled.img`
  width: 120px;
`
